const FALLBACK_TIMEOUT_MS = 1500;
const RENDER_TIMEOUT_MS = 3000;

const guardStates = new WeakMap();

function resolveGuard(guard) {
  if (guard.dataset.atcState !== 'loading') return;
  guard.dataset.atcState = 'resolved';
}

function clearGuardState(guard) {
  const state = guardStates.get(guard);
  if (!state) return;
  if (state.timeoutId) clearTimeout(state.timeoutId);
  if (state.observer) state.observer.disconnect();
  if (state.releaseObserver) state.releaseObserver.disconnect();
  guardStates.delete(guard);
}

function startGuardTimers(guard) {
  clearGuardState(guard);

  const bisTriggerInitial = guard.querySelector('.BIS_trigger');
  const baselineStyle = bisTriggerInitial ? bisTriggerInitial.getAttribute('style') : null;

  const timeoutId = setTimeout(() => resolveGuard(guard), FALLBACK_TIMEOUT_MS);

  const observer = new MutationObserver(() => {
    const bisTrigger = guard.querySelector('.BIS_trigger');

    // .BIS_triggerがまだ存在しない(注入待ち)場合は解決しない
    if (!bisTrigger) return;

    const currentStyle = bisTrigger.getAttribute('style');

    // 新しく挿入された要素で、まだstyle属性が付いていない場合も待つ
    if (currentStyle === null) return;

    if (currentStyle !== baselineStyle) {
      clearGuardState(guard);
      resolveGuard(guard);
    }
  });

  observer.observe(guard, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });

  guardStates.set(guard, { timeoutId, observer });
}

function watchGuard(guard) {
  clearGuardState(guard);

  // coming soon商品：発売(is-released付与)まではタイマー/監視を開始せず待機する
  const comingSoonWrap = guard.closest('.js-cs-wrap');
  if (comingSoonWrap && !comingSoonWrap.classList.contains('is-released')) {
    const releaseObserver = new MutationObserver(() => {
      if (comingSoonWrap.classList.contains('is-released')) {
        releaseObserver.disconnect();
        startGuardTimers(guard);
      }
    });
    releaseObserver.observe(comingSoonWrap, {
      attributes: true,
      attributeFilter: ['class'],
    });
    guardStates.set(guard, { releaseObserver });
    return;
  }

  startGuardTimers(guard);
}

function getVariantId(form) {
  return form?.querySelector('input[name="id"]')?.value ?? null;
}

// variant切替時：Shopifyのセクション再描画が完了するまで解除しない。
// Horizonの再描画はDOMをモーフ(同一ノードを書き換え)するため addedNodes では検知できず、
// また .BIS_trigger の style は再描画より約1.5秒早く変化するため、これらは解除条件に使えない。
// input[name="id"] の値は再描画完了と同一フレームで切り替わるため、これを唯一の解除トリガとする。
function watchVariantRender(guard) {
  clearGuardState(guard);

  const form = guard.closest('product-form-component');
  if (!form) {
    startGuardTimers(guard);
    return;
  }

  const baselineId = getVariantId(form);

  const finish = () => {
    clearGuardState(guard);
    resolveGuard(guard);
  };

  const timeoutId = setTimeout(finish, RENDER_TIMEOUT_MS);

  const observer = new MutationObserver(() => {
    if (getVariantId(form) !== baselineId) finish();
  });

  observer.observe(form, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  guardStates.set(guard, { timeoutId, observer });
}

function resetGuard(guard) {
  guard.dataset.atcState = 'loading';

  // coming soon(未発売)は従来どおり is-released 待ち
  const comingSoonWrap = guard.closest('.js-cs-wrap');
  if (comingSoonWrap && !comingSoonWrap.classList.contains('is-released')) {
    watchGuard(guard);
    return;
  }

  watchVariantRender(guard);
}

function findGuardsForProduct(productId) {
  return document.querySelectorAll(
    `product-form-component[data-product-id="${productId}"] .atc-visibility-guard`
  );
}

function initGuards(root) {
  root.querySelectorAll('.atc-visibility-guard[data-atc-state="loading"]').forEach(watchGuard);
}

initGuards(document);

// variant-picker内のラジオボタン選択をトリガーに、対応する
// product-form-component配下の.atc-visibility-guardをloadingへ能動的にリセットする
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

  const picker = target.closest('variant-picker');
  if (!picker) return;

  const productId = picker.dataset.productId;
  if (!productId) return;

  findGuardsForProduct(productId).forEach(resetGuard);
}, true);

// クイックビュー等でDOMに新しく挿入された.atc-visibility-guardを検知して監視対象に加える
const bodyObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches?.('.atc-visibility-guard')) {
        watchGuard(node);
      }
      node.querySelectorAll?.('.atc-visibility-guard').forEach(watchGuard);
    });
  }
});

bodyObserver.observe(document.body, {
  childList: true,
  subtree: true,
});